import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_accents: FaireCategoryEntity = {
  token: "cat_home-decor-accents",
  type: "category",
  name: "Home accents",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/home-accents",
  childCategoryTokens: [
    "cat_accents-all",
    "cat_accents-artificial-plants",
    "cat_accents-bookends",
    "cat_accents-curtains",
    "cat_accents-decorative",
    "cat_accents-frames",
    "cat_accents-furniture",
    "cat_accents-lighting",
    "cat_accents-ornaments",
    "cat_accents-pots-plants",
    "cat_accents-rugs",
    "cat_accents-tabletop-decor",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
